import { memo } from 'react';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { format } from 'date-fns/format';
import { formatDistanceToNow } from 'date-fns/formatDistanceToNow';

interface Props {
    value?: number | null;
    /** Shown when there is no timestamp at all. */
    empty?: string;
}

/**
 * "3 days ago" rather than "08/19/2026, 12:25 PM".
 *
 * These columns are scanned to answer "is this recent?", and a 22-character absolute timestamp
 * makes that a subtraction problem while eating the width other columns need. The exact value is
 * one hover away, and sorting is unaffected — the grid sorts the underlying number, not this.
 */
function TableDate({ value, empty = '—' }: Props) {
    if (!value) {
        return (
            <Typography variant="body2" sx={{ color: 'text.disabled' }}>
                {empty}
            </Typography>
        );
    }

    return (
        <Tooltip title={format(value, 'PPpp')}>
            <Typography variant="body2" sx={{ cursor: 'default' }}>
                {formatDistanceToNow(value, { addSuffix: true })}
            </Typography>
        </Tooltip>
    );
}

export default memo(TableDate);
